import { quizState } from "./quizState"
import { rerender } from "./render"

// ============================================================
// EXPLORE SCREEN NAVIGATION
// Same shape as `verifyState`. Visibility is owned by the DOM
// `.active` class on `#explore`. `backHome` in `quizState.ts`
// clears the class when navigating away.
// ============================================================

export function openExplore() {
  const home = document.getElementById("home")
  if (home) home.style.display = "none"
  quizState.screen = null
  document.getElementById("explore")?.classList.add("active")
  window.scrollTo({ top: 0, behavior: "smooth" })
  rerender()
}
